module.exports = __webpack_public_path__ + "img/login.fa251223.jpg";